
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36 36.467c0 .672-.241 1.316-.67 1.791a2.185 2.185 0 01-1.62.742H6.29c-.607 0-1.19-.267-1.62-.742A2.676 2.676 0 014 36.467V3.533c0-.672.241-1.316.67-1.791A2.185 2.185 0 016.29 1h22.908a2.18 2.18 0 011.599.72l4.513 4.869c.218.236.392.518.51.83.12.31.18.645.18.983v28.065z","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M14.5 16a3.5 3.5 0 100-7 3.5 3.5 0 000 7z","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30 29l-5.798-8.36a1.51 1.51 0 00-1.226-.64 1.513 1.513 0 00-1.242.614l-3.975 5.459-2.464-1.9a1.537 1.537 0 00-1.163-.298 1.5 1.5 0 00-1.014.623L10 29","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    